import { TagColor } from 'mbs-ui-kit';
import Company from './Company';

export enum TagType {
  BuiltIn,
  CustomGlobal,
  SpecifiedCompanies
}

export enum TagKind {
  Unknown,
  Computer
}

export type Tag = {
  id: number;
  name: string;
  kind: TagKind;
  type: TagType;
  color?: TagColor;
  allowedCompanies: Company[];
  /* Can be null by design, if request doesn't include calculateCount param */
  computersCount: number | null;
};
